// src/pages/dashboard/Cards.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MastercardCardSection } from '../../components/dashboard/mastercard/MastercardCardSection';

export default function Cards() {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">{t('cards.myCards')}</h1>
      <MastercardCardSection />
    </div>
  );
}

// CODIGO ORIGINAL COMENTADO PARA FUTURO USO
/*
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import mastercardBgImage from '../../assets/images/mastercard-bg.png';
import visacardBgImage from '../../assets/images/visa-card1.jpg';
import zeroDataImage from '../../assets/images/BELOBABA-ZERODATA.jpg'
import NewAlert from '../../components/dashboard/NewAlert';
import { useCardData } from '../../hooks/hooks';
import { cardService } from '../../services/api/card.service';
import { useWindow } from '../../context/WindowContext';
export default function Cards_ORIGINAL() {
  const navigate = useNavigate();
   const { windowWidth } = useWindow();
  const [cardsWithDetails, setCardsWithDetails] = useState<any[]>([]);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isNewOpen, setIsNewOpen] = useState<boolean>(false);

  const newsViewCache = localStorage.getItem('newsView') || "false";
  const newsView = JSON.parse(newsViewCache);
  const content = "New card coming soon!";

  // Consulta para obtener la lista de tarjetas
  const { data: cardsData, isLoading: isLoadingCards, error } = useCardData()
  // const { data: cardsData, isLoading: isLoadingCards, error } = useQuery({
  //   queryKey: ['verestro-cards'],
  //   queryFn: async () => {
  //     try {
  //       const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  //       const response = await fetch('https://api.v2.belobaba.io/api/verestro/cards', {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         }
  //       });

  //       if (!response.ok) {
  //         throw new Error(`Failed to fetch cards: ${response.status}`);
  //       }

  //       const data = await response.json();

  //       // Estructura para manejar diferentes formatos de respuesta
  //       if (data.success && data.data) {
  //         if (data.data.data && Array.isArray(data.data.data)) {
  //           return data.data.data;
  //         } else if (data.data.content && Array.isArray(data.data.content)) {
  //           return data.data.content;
  //         } else if (Array.isArray(data.data)) {
  //           return data.data;
  //         }
  //       }
  //       return [];
  //     } catch (error) {
  //       console.error('Error fetching cards:', error);
  //       throw error;
  //     }
  //   },
  //   staleTime: 60000, // 1 minuto
  // });

  // Obtener detalles de las tarjetas - usando el mismo enfoque que CardDetail.tsx
  useEffect(() => {
    const fetchCardDetails = async () => {
      if (!cardsData || !Array.isArray(cardsData) || cardsData.length === 0) {
        setCardsWithDetails([]);
        return;
      }

      setIsLoadingDetails(true);

      try {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');

        // Obtener detalles de cada tarjeta en paralelo
        const detailPromises = cardsData.map(async (card) => {
          if (!card.id) return card;
          return cardService.getCardItem(card)
        });

        const updatedCards = await Promise.all(detailPromises);
        console.log(updatedCards)
        setCardsWithDetails(updatedCards);
      } catch (error) {
        console.error('Error fetching card details:', error);
        setCardsWithDetails(cardsData || []);
      } finally {
        setIsLoadingDetails(false);
      }
    };

    fetchCardDetails();
  }, [cardsData]);
  const setNews = () => {
    setIsNewOpen(false)
    localStorage.setItem('newsView', "true");
  }
  // Extraer y formatear los últimos 4 dígitos
  const formatCardNumber = (card: any) => {
    // Primero intentar con cardNo completo (igual que en CardDetail.tsx)
    if (card.cardNo) {
      const clean = card.cardNo.replace(/\s/g, '');
      if (clean.length >= 4) {
        return `XXXX XXXX XXXX ${clean.slice(-4)}`;
      }
    }

    // Luego intentar con maskedPan
    if (card.maskedPan) {
      const matches = card.maskedPan.match(/([0-9]{4})$/);
      if (matches) {
        return `XXXX XXXX XXXX ${matches[1]}`;
      }
    }

    // Como último recurso, usar el cardNumber
    if (card.cardNumber) {
      const clean = card.cardNumber.replace(/\s/g, '');
      if (clean.length >= 4) {
        return `XXXX XXXX XXXX ${clean.slice(-4)}`;
      }
    }

    return 'XXXX XXXX XXXX XXXX';
  };

  // Manejar clic para ir a detalles de tarjeta
  const handleCardClick = (cardId: string) => {
    navigate(`/dashboard/cards/${cardId}`);
  };

  // Determinar si hay tarjetas
  const hasCards = cardsWithDetails.length > 0;
  const isLoading = isLoadingCards || isLoadingDetails;
  // const [windowSize, setWindowSize] = useState({
  //   width: window.innerWidth,
  // });

  useEffect(() => {
    
    if (!newsView) {
      setIsNewOpen(true);
    }
   
  }, []);
  console.log(typeof(windowWidth));
  return (
    <div className={`${windowWidth <= 450 ? "p-2" : "p-4"} h-full`}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Your Cards</h1>

      {isLoading ? (
        <p>Loading your cards...</p>
      ) : error ? (
        <div>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '20px' }}>
            Error loading cards. Please try again later.
          </p>
          <Link
            to="/dashboard"
            style={{
              padding: '10px 20px',
              backgroundColor: '#f1f1f1',
              color: '#333',
              textDecoration: 'none',
              borderRadius: '4px',
              display: 'inline-block'
            }}
          >
            Go to Dashboard
          </Link>
        </div>
      ) : !hasCards ? (
        <div>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '20px' }}>
            You don't have any virtual cards yet. Go to the wallets page to create your first MasterCard.
          </p>
          <Link
            to="/dashboard/wallets"
            style={{
              padding: '10px 20px',
              backgroundColor: '#B3A369',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              display: 'inline-block'
            }}
          >
            Go to Wallets
          </Link>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px', paddingRight: "1px", paddingLeft: "1px" }}>
            View and manage your cards.
          </p>
          {(windowWidth <= 450) ? (
            <div >
              {cardsWithDetails.map((card) => (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.id)}
                  style={{ cursor: 'pointer' }}
                >
                  // Tarjeta MasterCard simplificada
                  <div style={{
                    width: '100%',
                    maxWidth: '345px',
                    height: '185px',
                    // maxWidth: '400px',
                    // height: '240px',
                    borderRadius: '12px',
                    color: 'white',
                    marginBottom: '30px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                    className="card-hover" // Clase para efecto hover
                  >
                    // Fondo de la tarjeta                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundImage: `url(${mastercardBgImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      zIndex: 1
                    }}></div>

                    // Contenido mínimo - solo el número formateado                    <div style={{
                      position: 'relative',
                      zIndex: 2,
                      height: '100%',
                      padding: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <div style={{
                        fontSize: '22px',
                        fontWeight: 'bold',
                        letterSpacing: '2px',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                      }}>
                        {formatCardNumber(card)}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div style={{
                width: '100%',
                maxWidth: '345px',
                height: '185px',
                // maxWidth: '400px',
                // height: '240px',
                borderRadius: '12px',
                color: 'white',
                marginBottom: '30px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
                className="card-hover" // Clase para efecto hover
              >
                {/* Fondo de la tarjeta                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${visacardBgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 1
                  }}></div>

                {/* Contenido mínimo - solo el número formateado                <div style={{
                  position: 'relative',
                  zIndex: 2,
                  height: '100%',
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* <div style={{
                            fontSize: '22px',
                            fontWeight: 'bold',
                            letterSpacing: '2px',
                            textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                        }}>
                            {formatCardNumber()}
                        </div>                </div>
              </div>

            </div>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(344px, 1fr))',
              gap: '30px'
            }}>
              {cardsWithDetails.map((card) => (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.id)}
                  style={{ cursor: 'pointer' }}
                >
                  // Tarjeta MasterCard simplificada
                  <div style={{
                    width: '100%',
                    // maxWidth: '345px',
                    // height: '210px',
                    maxWidth: '400px',
                    height: '240px',
                    borderRadius: '12px',
                    color: 'white',
                    marginBottom: '30px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                    className="card-hover" // Clase para efecto hover
                  >
                    // Fondo de la tarjeta                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundImage: `url(${mastercardBgImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      zIndex: 1
                    }}></div>

                    // Contenido mínimo - solo el número formateado                    <div style={{
                      position: 'relative',
                      zIndex: 2,
                      height: '100%',
                      padding: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <div style={{
                        fontSize: '22px',
                        fontWeight: 'bold',
                        letterSpacing: '2px',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                      }}>
                        {formatCardNumber(card)}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div style={{
                width: '100%',               
                maxWidth: '400px',
                height: '240px',
                borderRadius: '12px',
                color: 'white',
                marginBottom: '30px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
                className="card-hover" // Clase para efecto hover
              >
                {/* Fondo de la tarjeta                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${zeroDataImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  zIndex: 1
                }}></div>

                {/* Contenido mínimo - solo el número formateado                <div style={{
                  position: 'relative',
                  zIndex: 2,
                  height: '100%',
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* <div style={{
                            fontSize: '22px',
                            fontWeight: 'bold',
                            letterSpacing: '2px',
                            textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                        }}>
                            {formatCardNumber()}
                        </div>                </div>
              </div>
               <div style={{
                width: '100%',
                // maxWidth: '345px',
                // height: '210px',
                maxWidth: '400px',
                height: '240px',
                borderRadius: '12px',
                color: 'white',
                marginBottom: '30px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
                className="card-hover" // Clase para efecto hover
              >
                {/* Fondo de la tarjeta                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${visacardBgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  zIndex: 1
                }}></div>

                {/* Contenido mínimo - solo el número formateado                <div style={{
                  position: 'relative',
                  zIndex: 2,
                  height: '100%',
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* <div style={{
                            fontSize: '22px',
                            fontWeight: 'bold',
                            letterSpacing: '2px',
                            textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                        }}>
                            {formatCardNumber()}
                        </div>                </div>
              </div>
            </div>
          )}

        </div>
      )}

      {/* CSS para efecto hover      <style>
        {`
        .card-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
      `}
      </style>

      {isNewOpen && (
        <NewAlert isOpen={isNewOpen} onClose={setNews} content={content} />
      )}
    </div>
  );
}
*/